import { Drawer } from "melco-ui";
import { useTranslation } from "react-i18next";
import { ALL_PUBLISHED_STATES } from "../../../helper/publishedState";
import { useGetSupplierProduct } from "../../../hooks/supplierproducts/useGetSupplierProduct";
import { SupplierProductEditForm } from "../form/SupplierProductEditForm";


type SupplierProductEditDrawerProps = {


  isSupplierProductDrawerOpen: boolean;
  closeDrawerAction: () => void;
  supplierProductIdToUpdate: string;
};


export const SupplierProductEditDrawer: React.FC<
  SupplierProductEditDrawerProps
> = ({ closeDrawerAction, supplierProductIdToUpdate, isSupplierProductDrawerOpen }) => {
  const { t } = useTranslation();


  const {
    query: { data: supplierProduct, refetch },
    queryKey
  } = useGetSupplierProduct(
    supplierProductIdToUpdate ?? "",
    ALL_PUBLISHED_STATES
  );

  return (

    <Drawer
      title={t("supplierproducts.drawer.title")}
      placement="right"
      width={700}
      closable={true}
      onClose={() => closeDrawerAction()}
      open={isSupplierProductDrawerOpen}
      bodyStyle={{ padding: 10 }}

    >

      {isSupplierProductDrawerOpen && supplierProduct
        && <SupplierProductEditForm
          isSupplierProductDrawerOpen={isSupplierProductDrawerOpen}
          closeDrawerAction={closeDrawerAction}
          supplierProduct={supplierProduct}
          refetch={refetch}
          queryKey={queryKey} />
      }

    </Drawer>
  );
};
